<template>
  <div style="margin-left:20px;padding: 20px;">
    <el-page-header @back="goBack" content="详情页面">
    </el-page-header>
    <el-row style="margin-top:20px;" :gutter="20">
      <el-col :span="8">
        <div>
          <el-card shadow="hover" style="height: 900px;">
            <el-form class="refundInfo" label-position="left" label-width="120px">
              <h3 style="color:#808080">退货申请单</h3>
              <el-form-item label="售后单号">
                <el-input size="small" v-model="formLabelAlign.childOrderNo"></el-input>
              </el-form-item>
              <el-form-item label="售后类型">
                <el-button :disabled="true" v-if="formLabelAlign.type == 1" type="primary" size="small">退款</el-button>
                <el-button :disabled="true" v-if="formLabelAlign.type == 2" type="primary" size="small">退货</el-button>
                <!--                <el-button :disabled="true" v-if="formLabelAlign.type == 3" type="primary" size="small">换货</el-button>-->
              </el-form-item>
              <el-form-item label="发货状态">
                <el-button :disabled="true" type="primary" size="small">{{ formLabelAlign.statusName }}</el-button>
                <!--                <el-button :disabled="true" v-if="formLabelAlign.Status == 30" type="primary" size="small">未收到货</el-button>-->
              </el-form-item>
              <el-form-item label="退款金额">
                <el-input size="small" v-model="formLabelAlign.billRefundAmount"></el-input>
                <!-- <el-input size="small" v-model="formLabelAlign.refundAmount"></el-input> -->
              </el-form-item>
              <el-form-item label="实际退款金额">
                <el-input size="small" v-model="formLabelAlign.billActualRefundAmount"></el-input>
                <!-- <el-input size="small" v-model="formLabelAlign.actualRefundAmount"></el-input> -->
              </el-form-item>
              <el-form-item label="退款数量">
                <el-input size="small" v-model="formLabelAlign.applySkuNumber"></el-input>
              </el-form-item>
              <el-form-item label="运费">
                <div v-if="formLabelAlign.bearFreight == 2">
                  <span>客户承担</span> &nbsp;&nbsp;
                  <div style="display: inline-block">
                    <el-input size="small" v-model="formLabelAlign.freight"></el-input>
                  </div>
                </div>
                <div v-if="formLabelAlign.bearFreight == 4">
                  无需运费
                </div>
              </el-form-item>
              <el-form-item label="退款原因">
                <el-input size="small" v-model="formLabelAlign.reason"></el-input>
              </el-form-item>
              <el-form-item label="已发货数量">
                <el-input size="small" v-model="formLabelAlign.deliveredNumber"></el-input>
              </el-form-item>
              <el-form-item label="未发货数量">
                <el-input size="small" v-model="formLabelAlign.undeliveredNumber"></el-input>
              </el-form-item>
              <el-form-item label="补充说明文案">
                <el-input size="small" v-model="formLabelAlign.attachContent"></el-input>
              </el-form-item>
              <el-form-item label="补充凭证">
                <div v-for="(item, index) in attachPics">
                  <img style="width: 200px;height:200px;display: inline-block;" :src="item" />
                </div>
              </el-form-item>
            </el-form>
          </el-card>
        </div>
      </el-col>
      <el-col :span="8">
        <div>
          <el-card shadow="hover" style="height: 900px;">
            <el-form class="goodsInfo" label-position="left" label-width="120px">
              <h3 style="color:#808080">商品信息</h3>
              <el-form-item label="子订单号">
                <el-input size="small" v-model="formLabelAlign.thirdOrderId"></el-input>
              </el-form-item>
              <el-form-item label="外部订单号">
                <el-input size="small" v-model="formLabelAlign.childOrderNo"></el-input>
              </el-form-item>
              <el-form-item label="商品名称">
                <el-input size="small" v-model="formLabelAlign.skuName"></el-input>
              </el-form-item>
              <el-form-item label="品牌">
                <el-input size="small" v-model="formLabelAlign.brandName"></el-input>
              </el-form-item>
              <el-form-item label="型号">
                <el-input size="small" v-model="formLabelAlign.modelCode"></el-input>
              </el-form-item>
              <el-form-item label="规格">
                <el-input size="small" v-model="formLabelAlign.skuSpecs"></el-input>
              </el-form-item>
            </el-form>
          </el-card>
        </div>
      </el-col>
      <el-col :span="8">
        <div>
          <el-card shadow="hover" style="height: 900px;">
            <el-form class="orderInfo" label-position="left" label-width="120px">
              <h3 style="color:#808080">下单信息</h3>
              <el-form-item label="联系人">
                <el-input size="small" v-model="formLabelAlign.receiverName"></el-input>
              </el-form-item>
              <!-- <el-form-item label="联系电话">
                <el-input size="small" v-model="formLabelAlign.receiverPhone"></el-input>
              </el-form-item> -->
              <el-form-item label="收货地址">
                <el-input size="small" v-model="formLabelAlign.receiverAddress"></el-input>
              </el-form-item>
            </el-form>
          </el-card>
        </div>
      </el-col>
    </el-row>
    <el-row style="margin-top:20px;" :gutter="20">
      <el-col :span="12">
        <div>
          <el-card shadow="hover">
            <el-form class="refundInfo" label-position="left" label-width="120px">
              <h3 style="color:#808080">物流轨迹(退货物流)</h3>
              <el-form-item label="发货物流公司">
                <el-input size="small" v-model="formLabelAlign.returnLogisticsCompany"></el-input>
              </el-form-item>
              <el-form-item label="发货快递单号">
                <el-input size="small" v-model="formLabelAlign.returnLogisticsCode"></el-input>
              </el-form-item>
            </el-form>
            <div>
              <el-timeline>
                <el-timeline-item v-for="(activity, index) in logisInfo" :key="index" :timestamp="activity.time">
                  {{ activity.description }}
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-card>
        </div>
      </el-col>
      <el-col :span="12">
        <div>
          <el-card shadow="hover">
            <div class="block">
              <div style="margin-bottom: 40px;" class="radio">
                操作记录:
                <el-radio-group v-model="reverse">
                  <el-radio :label="1">售后记录</el-radio>
                  <el-radio :label="2">申诉记录</el-radio>
                  <el-radio :label="3">处理跟进</el-radio>
                </el-radio-group>
              </div>
              <el-timeline v-show="reverse == 1">
                <el-timeline-item v-for="(activity, index) in afterSalesRecords" :key="index"
                  :timestamp="activity.AuditTime">
                  {{ activity.AuditNo }}
                </el-timeline-item>
              </el-timeline>
              <div v-show="reverse == 2">
                <el-table :data="records" border>
                  <el-table-column center prop="createTime" label="申诉时间">
                  </el-table-column>
                  <el-table-column center prop="reason" label="申诉原因">
                  </el-table-column>
                  <el-table-column center label="申诉图片">
                    <template slot-scope="scope">
                      <div v-for="(item, index) in scope.row.showPic">
                        <img style="width:50px;height:50px;cursor: pointer;" :src="item">
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column center label="平台处理完成">
                    <template slot-scope="scope">
                      <el-button v-if="scope.row.auditChangeStatus == 0" type="danger" size="mini">状态未变更</el-button>
                      <el-button v-if="scope.row.auditChangeStatus == 1" type="primary" size="mini">已处理</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-show="reverse == 3">
                <el-card style="margin-bottom:20px;" v-for="(item, index) in remarkList">
                  <div style="margin:10px;">
                    <el-row>
                      <el-col :span="18">
                        {{ item.note }} <br />
                        <h4>{{ item.createUser }} &nbsp;&nbsp;{{ item.createTime }}</h4>
                      </el-col>
                      <el-col :span="6">
                        <img :src="item1" style="width:80px;height:80px;margin-right:5px;cursor: pointer;"
                          v-for="(item1, index1) in item.pics" />
                      </el-col>
                    </el-row>

                  </div>
                </el-card>
              </div>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// import {AfterSaleOrderAppealRecord, AfterSaleOrderAuditAppeal, AfterSaleOrderErpDetail} from "../../api/api";
import {
  GetOrderLogistics,
  OrderAfterSaleAppealRecord,
  OrderAfterSaleErpDetail,
  GetOrderLogisticsKSAX,
  OrderGetOrderNoteList, GetAfterSaleOrderNoteList
} from "../../../api/api";

export default {
  name: "Detail",
  data() {
    return {
      remarkList: [],
      noteLoading: false,
      ChoseStatus: ['待审核', '通过', '拒绝', '完成', '关闭'],
      FStatus: ['待审核', '通过', '拒绝'],
      attachPics: [],
      logisInfo: [],
      returnLogisticsCode: '',
      returnLogisticsCompanyId: '',
      afterSalesRecords: [],
      afterSaleOrderId: this.$route.query.afterSaleOrderId,
      formLabelAlign: {
        name: '啊实打实大',
        region: '啊实打实大',
        childOrderNo: '',
        returnLogisticsCompany: '',
        refundAmount: '',
        receiverAddress: '',
        receiverPhone: '',
        receiverName: '',
        skuSpecs: '',
        modelCode: '',
        skuName: '',
        brandName: '',
        type: null,
        actualRefundAmount: null,
        skuNumber: null,
        reason: null,
        pics: null,
      },
      reverse: 1,
      activities: [{
        content: '活动按期开始',
        timestamp: '2018-04-15'
      }, {
        content: '通过审核',
        timestamp: '2018-04-13'
      }, {
        content: '创建成功',
        timestamp: '2018-04-11'
      }],
      details: {},
      records: [],
      loading: false,
    }
  },
  created() {
    if (this.$route.query.afterSaleOrderId) {
      console.log('afterSaleOrderId', this.afterSaleOrderId)
      this.afterSaleOrderId = this.$route.query.afterSaleOrderId
      this.getDetail()
      this.getRecords()
      this.getRemarkList()
    }
  },
  methods: {
    async getRemarkList() {
      this.noteLoading = true;
      let res = await GetAfterSaleOrderNoteList({ afterSaleOrderId: this.orderId });
      if (res.data.success) {
        this.noteLoading = false;
        if (res.data.result && res.data.result.data) {
          res.data.result.data.forEach((item, index) => {
            if (item.images) {
              item.pics = item.images.split(',')
            }
          })
        }
        this.remarkList = res.data.result.data
      } else {
        this.noteLoading = false;
        this.$message.error(res.data.error.message);
      }
      console.log('订单备注', res);
    },
    async getRecords() {
      let res = await OrderAfterSaleAppealRecord({ afterSaleOrderId: this.afterSaleOrderId })
      console.log('jili', res);
      if (res.data.result.success) {
        if (res.data.result.data && res.data.result.data.length > 0) {
          res.data.result.data.forEach((item, index) => {
            if (item.pics) {
              item.showPic = item.pics.split(',')
            }
          })
        }
        this.records = res.data.result.data;
      } else {
        this.$message.error(res.data.msg);
      }
    },
    async getDetail() {
      let res = await OrderAfterSaleErpDetail({ afterSaleOrderId: this.afterSaleOrderId })
      console.log('res', res);
      if (res.data.success) {
        this.formLabelAlign = res.data.result.data
        this.returnLogisticsCode = res.data.result.data.returnLogisticsCode;
        this.returnLogisticsCompanyId = res.data.result.data.returnLogisticsCompanyId;
        if (res.data.result.data.attachUrl) {
          this.attachPics = res.data.result.data.attachUrl.split(',');
        }
        if (this.returnLogisticsCode && this.returnLogisticsCompanyId) {
          let params = {};
          params.logisticsCode = this.returnLogisticsCode;
          params.logisticsCompanyId = this.returnLogisticsCompanyId;
          GetOrderLogisticsKSAX(params).then((res) => {
            console.log('物流信息', res);
            if (res.data.success) {
              this.logisInfo = res.data.result.data;
            } else {
              this.$message.error(res.data.error.message);
            }
          });
        }
        if (res.data.result.data) {
          // res.data.response.forEach((item)=> {
          // this.afterSalesRecords.push({AuditTime:item.AuditNote,AuditNo:item.AuditNote})
          if (res.data.result.data.createTime) {
            this.afterSalesRecords.push({ AuditTime: res.data.result.data.createTime, AuditNo: this.ChoseStatus[res.data.result.data.accountManagerStatus] })
          }
          if (res.data.result.data.accountManagerTime) {
            this.afterSalesRecords.push({ AuditTime: res.data.result.data.accountManagerTime, AuditNo: this.ChoseStatus[res.data.result.data.accountManagerTime] })
          }
          if (res.data.result.data.businessTime) {
            this.afterSalesRecords.push({ AuditTime: res.data.result.data.businessTime, AuditNo: this.ChoseStatus[res.data.result.data.businessStatus] })
          }
          if (res.data.result.data.financeTime) {
            this.afterSalesRecords.push({ AuditTime: res.data.result.data.financeTime, AuditNo: this.FStatus[res.data.result.data.financeStatus] })
          }
          // })
        }
        console.log('this.afterSalesRecords', this.afterSalesRecords);
      } else {
        this.$message.error(res.data.result.message);
      }
    },
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>
<style scoped>
/deep/ .refundInfo .el-input__inner {
  border: none;
}

/deep/ .refundInfo .el-form-item__label {
  color: #66b1ff;
  font-weight: bold;
}

/deep/ .goodsInfo .el-input__inner {
  border: none;
}

/deep/ .goodsInfo .el-form-item__label {
  color: #66b1ff;
  font-weight: bold;
}

/deep/ .orderInfo .el-input__inner {
  border: none;
}

/deep/ .orderInfo .el-form-item__label {
  color: #66b1ff;
  font-weight: bold;
}
</style>